<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['suppliers.menu'])">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">{{ 'SUPPLIERS.SUPPLIERS_LIST.TITLE' | translate }}</h5>
    </div>
    <div class="col-auto ms-auto">
      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>

      <button
        *ngIf="
          accessService.hasAccess(
            [
              UserRoleType.RESERVATION_AGENT,
              UserRoleType.RESERVATION_MANAGER,
              UserRoleType.CONTRACTING_AGENT,
              UserRoleType.CONTRACTING_MANAGER,
              UserRoleType.FINANCE_AGENT,
              UserRoleType.FINANCE_MANAGER,
              UserRoleType.LEAD_GENERATION
            ],
            ['suppliers.store']
          )
        "
        type="button"
        class="btn btn-secondary"
        (click)="add()"
      >
        {{ 'SUPPLIERS.SUPPLIERS_LIST.ADD_SUPPLIER' | translate }}
      </button>

      <button
        *ngIf="
          accessService.hasAccess(
            [
              UserRoleType.RESERVATION_AGENT,
              UserRoleType.RESERVATION_MANAGER,
              UserRoleType.CONTRACTING_AGENT,
              UserRoleType.CONTRACTING_MANAGER,
              UserRoleType.FINANCE_AGENT,
              UserRoleType.FINANCE_MANAGER,
              UserRoleType.LEAD_GENERATION
            ],
            []
          )
        "
        type="button"
        class="btn btn-secondary"
        (click)="export()"
      >
        {{ 'SUPPLIERS.SUPPLIERS_LIST.EXPORT' | translate }}
      </button>
    </div>
  </div>
  <kendo-grid
    [data]="data"
    [pageSize]="suppliersResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Suppliers', grid, 2)"
  >
    <kendo-grid-column
      width="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'COUNTRIES.COUNTRIES_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'SUPPLIERS.SUPPLIERS_LIST.ID' | translate }}"
      filter="numeric"
      width="100"
      format="0"
      [hidden]="isHiddenColumn('id')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="name"
      title="{{ 'SUPPLIERS.SUPPLIERS_LIST.NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('name')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="type.value"
      title="{{ 'SUPPLIERS.SUPPLIERS_LIST.TYPE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('type.value')"
      width="110"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select [groupType]="'supplier'" [filter]="filter"></app-kendo-type-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.type"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="note"
      title="{{ 'SUPPLIERS.SUPPLIERS_LIST.NOTE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('note')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="contacts"
      title="{{ 'SUPPLIERS.SUPPLIERS_LIST.CONTACTS' | translate }}"
      [hidden]="isHiddenColumn('contacts')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngFor="let contact of dataItem.contacts; let i = index">
          <span class="contact-key">{{ contact?.type?.value }}:</span>
          <span class="contact-value">{{ contact?.value }} <span *ngIf="contact?.note">({{ contact?.note }})</span></span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="address"
      title="{{ 'SUPPLIERS.SUPPLIERS_LIST.ADDRESS' | translate }}"
      [hidden]="isHiddenColumn('address', true)"
      filter="text"
    ></kendo-grid-column>

    <kendo-grid-column
      field="registration_number"
      title="{{ 'SUPPLIERS.SUPPLIERS_LIST.REGISTRATION_NUMBER' | translate }}"
      [hidden]="isHiddenColumn('registration_number', true)"
      filter="text"
    ></kendo-grid-column>

    <kendo-grid-column
      field="vat_number"
      title="{{ 'SUPPLIERS.SUPPLIERS_LIST.VAT_NUMBER' | translate }}"
      [hidden]="isHiddenColumn('vat_number', true)"
      filter="text"
    ></kendo-grid-column>

    <kendo-grid-column
      field="responsible_person"
      title="{{ 'SUPPLIERS.SUPPLIERS_LIST.RESPONSIBLE_PERSON' | translate }}"
      [hidden]="isHiddenColumn('responsible_person', true)"
      filter="text"
    ></kendo-grid-column>

    <kendo-grid-column
      field="created_at"
      title="{{ 'SUPPLIERS.SUPPLIERS_LIST.CREATED_AT' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('created_at', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.created_at.getDate() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="active"
      title="{{ 'SUPPLIERS.SUPPLIERS_LIST.ACTIVE' | translate }}"
      filter="boolean"
      width="100"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('active')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.active"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'SUPPLIERS.SUPPLIERS_LIST.ACTIONS' | translate }}"
      width="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-edit-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION
              ],
              ['suppliers.show']
            )
          "
          (click)="edit(dataItem)"
        >
        </app-edit-button>

        <app-delete-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION
              ],
              ['suppliers.destroy']
            )
          "
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>

    <ng-template kendoGridDetailTemplate let-dataItem>
      <kendo-grid [data]="dataItem.companies">
        <kendo-grid-column
          headerClass="pt-1 pb-1"
          field="abbreviation"
          title="{{ 'SUPPLIERS.SUPPLIERS_LIST.COMPANY' | translate }}"
        ></kendo-grid-column>

        <kendo-grid-column headerClass="pt-1 pb-1" title="{{ 'SUPPLIERS.SUPPLIERS_LIST.PROPERTIES' | translate }}">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div *ngFor="let property of dataItem.properties; let i = index" class="d-inline-block">
              <span class="property-key">{{ property?.type?.value }}:</span>
              <span class="property-value">{{ property?.value }}</span>
            </div>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </ng-template>
  </kendo-grid>
</div>
